import { useTranslation } from 'react-i18next';
import styles from './MailCardAuthGate.module.css';

interface MailCardAuthGateProps {
  onSignInRequest: () => void;
}

/**
 * Guest sign-in CTA inside MailCardSheet. Mounts the parent's
 * AuthModal via the onSignInRequest callback. Stateless;
 * MailCardSheet's onAuthStateChange listener flips authPhase to
 * 'authed' after a successful sign-in (email OTP path; Google
 * OAuth follows the full-page-redirect re-entry path documented
 * in the plan § 8).
 *
 * Phase 2A foundation component. Phase 1 i18n keys consumed:
 * mailCard.authGate.helper, mailCard.authGate.cta.
 */
export default function MailCardAuthGate({
  onSignInRequest,
}: MailCardAuthGateProps) {
  const { t } = useTranslation();

  return (
    <section className={styles.gate} aria-label={t('mailCard.authGate.helper')}>
      <p className={styles.helper}>{t('mailCard.authGate.helper')}</p>
      <button
        type="button"
        className={styles.cta}
        onClick={onSignInRequest}
        aria-label={t('mailCard.authGate.cta')}
      >
        {t('mailCard.authGate.cta')}
      </button>
    </section>
  );
}
